<template>
  <div class="wrapper-sticky">
    <nav-header></nav-header>

    <main class="has-padding-lr-7 has-padding-bt-1-not-on-mobile content-sticky">
      <section>
        <div class="container">
          <div class="content">

            <!--Block 0-->
            <h1 class="has-text-giada-green has-padding-b-6 has-padding-t-1">
              {{title}}
            </h1>

            <!--Block 1-->
            <p class="has-text-raven-grey">
              {{subtitle}}
            </p>

            <!--Block 6-->
            <div class="columns">
              <div class="column is-two-fifths" >
                <div class="hero is-white">
                  <contact-form></contact-form>
                </div>
              </div>
              <div class="column" ></div>
              <div class="column is-two-fifths has-vertically-aligned-content">
                <figure class="image is-marginless">
                  <a :href=locationMap class="has-position-absolute is-size-3 has-text-solitude-white is-horizontal-centered">
                    <i class="fas fa-map-marker-alt"></i>
                    <p class="has-text-weight-semibold is-size-5">{{mapText}}</p>
                  </a>
                  <img class="is-circle" src="../assets/img/location_SoHoGiadify.png">
                </figure>
                <address class="is-standard has-text-centered has-margin-b-6">
                  <p class="is-size-5 has-margin-b-7 has-text-weight-semibold has-text-giada-green">{{addressTitle}}</p>
                  <p class="is-marginless has-text-tuna-grey">{{address1}}</p>
                  <p class="is-marginless has-text-tuna-grey">{{address2}}</p>
                  <p class="is-marginless has-text-tuna-grey">{{address3}}</p>
                </address>
              </div>
            </div>

          </div>
        </div>
      </section>
    </main>

    <nav-footer v-bind:isLanding="isLanding" v-bind:isClear="isClear"></nav-footer>
  </div>
</template>

<script>
import NavHeader from './general/NavHeader'
import NavFooter from './general/NavFooter'
import ContactForm from './contactPage/ContactForm'

export default {
  name: 'privacy-body',
  data: function () {
    return {
      title: 'Get in Touch',
      subtitle: 'Fill out the quick form, we will be in touch with lightening speed.',
      mapText: 'Click for the Map',
      addressTitle: 'We are located in the heart of SoHo',
      address1: '447 Broadway, 2nd Floor',
      address2: 'New York, NY, 10013',
      address3: 'United States',
      locationMap: 'https://www.google.com/maps/place/447+Broadway+2nd+Floor,+New+York,+NY+10013/@40.7205993,-74.0036708,17z/data=!3m1!4b1!4m5!3m4!1s0x89c2598a32c0eea7:0x1b4695e7ff832789!8m2!3d40.7205993!4d-74.0014821',
      isLanding: false,
      isClear: false
    }
  },
  components: {
    NavHeader,
    NavFooter,
    ContactForm
  }
}
</script>

<style scoped>
  .is-horizontal-centered {
    top: 70%;
    left: 50%;
    transform: translateX(-50%);
  }
  .is-standard {
    font-style: normal;
  }

  @media only screen and (min-width: 768px) {
    .has-padding-bt-1-not-on-mobile{
      padding-top: 3rem;
      padding-bottom: 3rem;
    }
  }

  .has-vertically-aligned-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  /*.wrapper-sticky {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
  }*/

  .content-sticky {
    /*flex: 1;*/
    min-height: calc(100vh - 170px);
  }
</style>



// WEBPACK FOOTER //
// src/components/ContactPage.vue